import { render } from "./_Header.vue?vue&type=template&id=1fc52ef2&scoped=true"
import script from "./_Header.vue?vue&type=script&lang=js"
export * from "./_Header.vue?vue&type=script&lang=js"

import "./_Header.vue?vue&type=style&index=0&id=1fc52ef2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1fc52ef2"

export default script